import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "@evergis/ui";

import { DataSourceErrorContainer } from "../../styled";

export const DataSourceError: FC<{ name: string }> = ({ name }) => {
  const { t } = useTranslation("featureCard");

  return (
    <DataSourceErrorContainer>
      <Icon kind="alert" />
      <div>
        {t("block")} &quot;{name}&quot; {t("isNotLoaded")}
      </div>
    </DataSourceErrorContainer>
  );
};
